import * as React from "react";
import styled from "styled-components";
import { PanelStack, Classes, IPanel } from "@blueprintjs/core";
import { KennelOwnersSelectionPanel } from "./KennelOwnersSelectionPanel";
import { PersonGridDto } from "../../../../../api";
import {
  KennelOwnerSavePanel,
  IKennelOwnerSavePanelProps,
} from "./KennelOwnerSavePanel";
import { useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IKennelOwnersPanelStackProps
  extends Pick<IKennelOwnerSavePanelProps, "onSaved"> {
  kennelId: number;
  kennelOwnershipId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const KennelOwnersPanelStack: React.FunctionComponent<IKennelOwnersPanelStackProps> = ({
  kennelId,
  onSaved,
  kennelOwnershipId,
}) => {
  const { t } = useTl();
  const onSectionSelected = React.useCallback(
    (data: PersonGridDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => (
            <KennelOwnerSavePanel
              onSaved={onSaved}
              person={data}
              kennelId={kennelId}
              kennelOwnershipId={kennelOwnershipId}
            />
          ),
        },
      ]);
    },
    [kennelId, kennelOwnershipId, onSaved]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => (
        <KennelOwnersSelectionPanel onPersonSelected={onSectionSelected} />
      ),
      title: t(ETLCodes.Owners),
    },
  ]);

  React.useEffect(() => {}, [panelStack]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return !kennelOwnershipId || kennelOwnershipId === 0 ? (
    <Container>
      <PanelStack
        stack={panelStack}
        showPanelHeader={true}
        onClose={removeFromPanelStack}
      />
    </Container>
  ) : (
    <Container>
      {" "}
      <KennelOwnerSavePanel
        onSaved={onSaved}
        person={null}
        kennelId={kennelId}
        kennelOwnershipId={kennelOwnershipId}
      />{" "}
    </Container>
  );
};
